// Navegação da sidebar + índice de busca do /docs.

export interface DocsNavItem {
  href: string;
  label: string;
}

export const DOCS_NAV: DocsNavItem[] = [
  { href: '/docs', label: 'Visão geral' },
  { href: '/docs/pixel', label: 'Pixel & Tracker' },
  { href: '/docs/proxy-first-party', label: 'Proxy first-party' },
  { href: '/docs/capi', label: 'CAPI server-side' },
  { href: '/docs/integracoes', label: 'Integrações' },
  { href: '/docs/publicos', label: 'Públicos automáticos' },
  { href: '/docs/mcp', label: 'MCP' },
  { href: '/docs/api-tracker', label: 'API /v1/track' },
];

export interface DocsSearchItem {
  href: string;
  label: string;
  description: string;
  /** Termos extras pra casar na busca (não exibidos). */
  keywords: string;
}

export const DOCS_SEARCH: DocsSearchItem[] = [
  {
    href: '/docs',
    label: 'Visão geral',
    description: 'Ponto de partida da documentação técnica do Trakd e a stack que roda por trás.',
    keywords: 'overview início stack tecnologia next supabase redis bullmq meta graph',
  },
  {
    href: '/docs/pixel',
    label: 'Pixel & Tracker',
    description:
      'Snippet JS, first-party cookies, eventos automáticos e deduplicação client-vs-server.',
    keywords:
      'pixel tracker snippet javascript cookie itp safari fbclid utm dedup event_id pageview',
  },
  {
    href: '/docs/proxy-first-party',
    label: 'Proxy first-party',
    description:
      'Sirva o track.js e o /v1/track pelo seu domínio (rewrite Next.js ou nginx) e escape de adblockers.',
    keywords:
      'adblock ublock adguard brave proxy first party rewrite nginx next data-api cdn bloqueio eventos perdidos',
  },
  {
    href: '/docs/capi',
    label: 'CAPI server-side',
    description: 'Conversions API: payload, event_id, hashing de PII, EMQ e deduplicação na Meta.',
    keywords:
      'capi conversions api server-side emq hashing pii sha256 deduplicação graph v23 eventos',
  },
  {
    href: '/docs/integracoes',
    label: 'Integrações',
    description:
      'Integrações nativas: Hotmart, Kiwify, Cakto, Stripe, Shopify e mais. Setup de webhook por provedor.',
    keywords:
      'integrações gateways webhook hotmart kiwify cakto eduzz kirvano hubla perfectpay lastlink ticto lowify ggcheckout stripe shopify woocommerce yampi assinatura secret',
  },
  {
    href: '/docs/publicos',
    label: 'Públicos automáticos',
    description:
      'Custom audiences de reembolsados, reembolsados semelhantes e carrinho abandonado.',
    keywords:
      'públicos custom audiences reembolsados lookalike negativo semelhantes carrinho abandonado exclusão cac',
  },
  {
    href: '/docs/mcp',
    label: 'MCP',
    description: 'Conecte os dados do seu workspace à sua IA (Claude e outros), em modo leitura.',
    keywords:
      'mcp model context protocol ia claude ai token oauth reports read leitura dados workspace',
  },
  {
    href: '/docs/api-tracker',
    label: 'API /v1/track',
    description: 'Eventos server-to-server pra cenários custom além dos gateways nativos.',
    keywords: 'api track endpoint server-to-server eventos backend custom integração',
  },
];
